var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet-takt"},[_vm._t("dialog"),_c('div',[_vm._t("header")],2),_c('div',{staticClass:"wallet-takt-body-slot",style:(_vm.selected ? 'top: calc(100% - 68px); overflow: hidden;' : '' + (_vm.$store.state.View.is_printing_mode ? '' : 'overflow: auto;')),attrs:{"id":'wallet_body_slot' + _vm.takt_index}},[_vm._t("body")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }